module.exports = __webpack_public_path__ + "static/media/bagasi.323e6826.svg";